import React, { useEffect, useState, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from 'react-redux';
import { formatCellValue, formatDateForDisplay } from "../Utils/UtilityFunctions";

function ComponentList() {
  const dispatch = useDispatch()
  const arr = [];
  const columns = useMemo(
    () => [
      {
        accessorKey: "of",
        header: "   Component Name",
        Cell: ({ cell }) => formatCellValue(cell.getValue())
      },
      {
        accessorKey: "offe",
        header: "Variable Name",
        Cell: ({ cell }) => formatCellValue(cell.getValue())
      },
    ],
    []
  );

  return (
    <div className="table-responsive border mt-5">
      {arr ?
        (
          <MaterialReactTable columns={columns} data={arr}
            muiTableHeadCellProps={{
              sx: {
                fontFamily: "Inter,sans-serif"
              }
            }}
            enableTopToolbar={false}
            enableColumnActions={true}
            muiTableBodyCellProps={{
              sx: {
                fontFamily: "Inter,sans-serif"
              }
            }}
          />
        ) : null}
    </div>
  );
}

export default ComponentList;
